<template>
  <z-dialogo ref="dialogoExibirPagamentos" titulo="Pagamentos" :dividers="true" largura="1000px" altura="400px" scrollable>
    <template v-slot:prepend>
      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12" sm="3">
            <v-text-field filled dense v-model="documento.documento" label="Promissória" readonly hide-details></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <z-date-picker-menu filled dense v-model="documento.vencimento" label="Vencimento" readonly hide-details></z-date-picker-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <z-campo-valor filled dense v-model="documento.valor" label="Valor Promissória" readonly hide-details></z-campo-valor>
          </v-col>
          <v-col cols="12" sm="3">
            <z-campo-valor filled dense v-model="documento.valor_restante" label="Valor Restante" readonly hide-details></z-campo-valor>
          </v-col>
        </v-row>
      </v-card-text>
    </template>

    <template v-slot:texto>
      <z-loading :loading="loading" height="100px" color="primary"></z-loading>
      <div v-if="!loading">
        <p class="subtitle-2 font-weight-bold">Pagamentos Efetuados</p>
        <v-divider></v-divider>
        <h3 class="text-center mt-5" v-if="pagamentosStore.extrato.historico.length == 0">Nenhum pagamento efetuado nessa promissória</h3>
        <v-data-table v-if="pagamentosStore.extrato.historico.length > 0" :headers="headers" :items="pagamentosStore.extrato.historico" hide-default-footer>
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.created_at | dataBR }}</td>
              <td class="text-right">{{ props.item.valor_atual | valorBR}}</td>
              <td class="text-right font-weight-bold">{{ props.item.valor_pago | valorBR}}</td>
              <td class="text-right">{{ props.item.valor_restante | valorBR}}</td>
            </tr>
          </template>
        </v-data-table>
      </div>

    </template>
    <v-btn color="primary" text @click="fechar">Fechar</v-btn>
  </z-dialogo>
</template>

<script setup>
import { ref } from 'vue'
import { usePagamentosStore } from '@/app/store/pinia/pagamentos'

// Store
const pagamentosStore = usePagamentosStore()

// Reactive data
const loading = ref(false)
const historico = ref([])
const dialogoExibirPagamentos = ref(null)

const headers = [
  { text: '#', value: 'id', sortable: false },
  { text: 'Data', value: 'created_at', sortable: false },
  { text: 'Valor Original', value: 'valor_original',  align: 'right', sortable: false },
  { text: 'Valor Pago', value: 'valor_pago',  align: 'right', sortable: false },
  { text: 'Valor Restante', value: 'valor_restante', align: 'right', sortable: false },
]

const documento = ref({
  contapagar_id: 0,
  documento: '',
  valor: 0,
  valor_restante: 0
})

// Methods
const abrir = async (doc) => {
  documento.value.contapagar_id  = doc.id
  documento.value.documento      = doc.documento
  documento.value.valor          = doc.valor ? doc.valor : doc.valor_original
  documento.value.valor_restante = doc.valor_restante
  documento.value.vencimento     = doc.vencimento
  documento.value.observacoes    = doc.observacoes
  dialogoExibirPagamentos.value.abrir()
  
  try {
    loading.value = true
    historico.value = await carregarHistorico(doc.id)
  } catch (error) {
    console.log('Algo deu errado ao carregar o histórico de pagamentos: ', error)
  } finally {
    loading.value = false
  }
}

const fechar = () => {
  dialogoExibirPagamentos.value.fechar()
}

const carregarHistorico = async (documento) => {
  try {
    await pagamentosStore.historicoPagamento(documento)
  } catch (error) {
    console.error('Erro ao carregar histórico de pagamentos:', error)
    throw error
  }
}

// Expose methods to template
defineExpose({
  abrir
})
</script>

<style scoped>

</style>